<template>
  <div>
    <div class="head">
      <el-button type="primary" style="width: 80px" size="small" @click="addBtn">新增</el-button>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: '#eee', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%">
        <el-table-column
          type="index"
          :index='(index) => {return index + 1 + (curPage-1)*limit}'
          label="序号"
          width="70">
        </el-table-column>
        <el-table-column prop="activitieName" label="活动标题" />
        <el-table-column prop="activitieTime" label="活动日期">
          <template slot-scope="{ row }">
            {{ row.activitieTime | timeFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="activitiePlace" label="活动地点" />
        <el-table-column prop="compere" label="活动主持人"  />
        <el-table-column prop="hostDep" label="主办部门" />
        <el-table-column prop="coreTeamEmpNames" label="主要参与人员" />
        <el-table-column label="是否发布">
          <template slot-scope="{ row }">
            {{ row.isIssue === 0 ? '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column prop="activitieContent" label="活动内容" />
        <el-table-column prop="activitieSummary" label="活动情况与总结" />
        <el-table-column label="操作">
          <template slot-scope="{ row }">
            <el-button type="text" style="color: #409EFF" @click="editBtn(row)">编辑</el-button>
            <el-button type="text" style="color: #F56C6C" @click="deleteBtn(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
      </div>
    </div>
  </div>
</template>

<script>
import { safetyActivityInfoList, safetyActivityInfoDelete } from '@/api/processManager'
export default {
  name: 'safetyActivityInfo',
  data() {
    return {
      tableData: [],
      limit: 10,
      curPage: 1,
      total: 0
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      safetyActivityInfoList({ limit: this.limit, curPage: this.curPage }).then(res => {
        this.tableData = res.body.data;
        this.total = res.body.cum
      })
    },
    curPageChange(val) {
      this.curPage = val
    },
    addBtn() {
      this.$router.push('AddSafetyActivity');
    },
    // 编辑
    editBtn(row) {
      let obj = { ...row }
      for(let i in obj) {
        if(obj[i] === undefined || obj[i] === null || obj[i] === '') {
          delete obj[i]
        }
      }
      obj.coreTeamEmpIds = row.coreTeamEmpIds.split(',')
      for(let j in obj.coreTeamEmpIds) {
        obj.coreTeamEmpIds[j] = Number(obj.coreTeamEmpIds[j])
      }
      delete obj.gmtCreate
      // console.log(obj)
      // return
      this.$router.push(
        {
          name: 'AddSafetyActivity',
          params: { key: obj }
        }
      )
    },
    // 删除
    deleteBtn(row) {
      this.$confirm(`删除活动 “${row.activitieName}” , 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        safetyActivityInfoDelete(row.id).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getData()
        })
      }).catch(() => {
        return       
      });
    }
  }
}
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 280px)
}
</style>